/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
export const MEDIA_GUIDELINE_QUERY_KEYS = {
  all: ['media-guidelines'] as const,
  list: (filters?: Record<string, unknown>) =>
    [...MEDIA_GUIDELINE_QUERY_KEYS.all, 'list', filters ?? {}] as const,
  detail: (id: string) => [...MEDIA_GUIDELINE_QUERY_KEYS.all, 'detail', id] as const,
  history: (id: string) => [...MEDIA_GUIDELINE_QUERY_KEYS.all, 'history', id] as const,
  categories: () => [...MEDIA_GUIDELINE_QUERY_KEYS.all, 'categories'] as const,
  platformRules: () => [...MEDIA_GUIDELINE_QUERY_KEYS.all, 'platform-rules'] as const,
};
